import * as React from "react"
export const Svg_028 = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={59}
    height={59}
    fill="none"
  >
    <g clipPath="url(#a)">
      <path
        fill="url(#b)"
        d="M56.958 29.804H59v-6.63h-6.63v2.043a4.593 4.593 0 0 0 4.588 4.587Z"
      />
      <path
        fill="url(#c)"
        d="M52.37 56.958V59H59v-6.63h-2.042a4.593 4.593 0 0 0-4.588 4.588Z"
      />
      <path
        fill="url(#d)"
        d="M56.958 33.261c-4.436 0-8.045-3.609-8.045-8.044v-2.043h-4.61v9.114H30.617a4.813 4.813 0 0 1 4.807 4.808h-3.457c0-.745-.605-1.35-1.35-1.35H28.84c-.996 0-1.807.81-1.807 1.806s.811 1.807 1.807 1.807h1.32a5.27 5.27 0 0 1 5.263 5.263 5.273 5.273 0 0 1-4.195 5.155v2.309h-3.457v-2.239a4.815 4.815 0 0 1-4.195-4.769h3.457c0 .745.606 1.351 1.351 1.351h1.776c.996 0 1.807-.81 1.807-1.807 0-.996-.811-1.806-1.807-1.806h-1.32a5.27 5.27 0 0 1-5.264-5.264 5.27 5.27 0 0 1 5.264-5.264H14.696v-9.114h-4.61v2.043c0 4.435-3.608 8.044-8.044 8.044H0v15.652h2.042c4.436 0 8.045 3.609 8.045 8.045V59h38.826v-2.042c0-4.436 3.61-8.045 8.045-8.045H59V33.261h-2.042ZM17.34 42.816h-3.457v-3.457h3.457v3.457Zm27.774 0h-3.457v-3.457h3.457v3.457Z"
      />
      <path
        fill="url(#e)"
        d="M2.042 52.37H0V59h6.63v-2.042a4.593 4.593 0 0 0-4.588-4.588Z"
      />
      <path
        fill="url(#f)"
        d="M6.63 25.217v-2.043H0v6.63h2.042a4.593 4.593 0 0 0 4.588-4.587Z"
      />
      <path
        fill="url(#g)"
        d="M40.847 28.831V10.107h-4.29v-3.05A7.064 7.064 0 0 0 29.5 0a7.064 7.064 0 0 0-7.056 7.056v3.05h-4.29v18.725h22.693ZM25.9 7.056c0-1.984 1.614-3.599 3.599-3.599s3.6 1.615 3.6 3.6v3.05h-7.2v-3.05Zm.538 9.997 2.032 2.033 4.09-4.09 2.445 2.444-6.535 6.535-4.477-4.477 2.445-2.445Z"
      />
    </g>
    <defs>
      <linearGradient
        id="b"
        x1={53.903}
        x2={57.053}
        y1={24.169}
        y2={29.265}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="c"
        x1={53.903}
        x2={57.053}
        y1={53.365}
        y2={58.461}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="d"
        x1={13.644}
        x2={26.16}
        y1={28.548}
        y2={61.908}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="e"
        x1={1.533}
        x2={4.682}
        y1={53.365}
        y2={58.461}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="f"
        x1={1.533}
        x2={4.682}
        y1={24.169}
        y2={29.265}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="g"
        x1={23.401}
        x2={38.276}
        y1={4.325}
        y2={23.274}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h59v59H0z" />
      </clipPath>
    </defs>
  </svg>
)